import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom'
import { AppProvider} from './context/AppContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
 
  
  <React.StrictMode>
     <AppProvider>
     
    <App />
      </AppProvider>
  </React.StrictMode>


  </BrowserRouter>
);



//api.js
//AppContext
//JobContext
